<app-patient-info [heading]="Item"></app-patient-info>

<div class="layout-dashboard">
    <div class="p-fluid formgrid grid mb-2">
        <div class="field col-12 md:col-4">
            <div class="card widget-tasks pt-0 pr-0 pb-6 pl-0"
                 style="
          border-top-left-radius: 20px !important;
          border-top-right-radius: 20px !important;
        ">
                <div class="DashboardCard dashboardTable">
                    <div class="card-header block mb-0 px-2">
                        <h5 style="">
                            <i class="pi">
                                <img src="../../../../assets/imagesNew/d_Problems.png"
                                     width="29"
                                     height="29"
                                     style="border: 1px solid #0d1b9c; border-radius: 1rem" />
                            </i>
                        </h5>
                        <div class="card-header-label">{{preferences?.problems || 'Problems'}}</div>
                    </div>
                    <p-table class="tableDashboard"
                             *ngIf="problem"
                             [columns]="problemcols"
                             [value]="problem"
                             selectionMode="single"
                             [resetPageOnSort]="false"
                             [lazy]="false"
                             [rows]="5"
                             [paginator]="false">
                        <ng-template *ngIf="problem?.length > 0"
                                     pTemplate="header"
                                     let-columns>
                            <tr>
                                <th *ngFor="let col of columns"
                                    [pSortableColumn]="col.field"
                                    class="datatable-tableHeader">
                                    {{ col.header }}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body"
                                     let-rowData
                                     let-columns="columns"
                                     let-i="rowIndex">
                            <tr [pSelectableRow]="rowData" (click)="redirectUrlLinks('problems')">
                                <td *ngFor="let col of columns" class="datatable-col">
                                    <span [innerHTML]="formatdatetime(rowData[col.field], col.header)" (mouseover)="handleMouseOver($event,'problems','Description')"></span>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="emptymessage">
                            <div class="w-12 pt-6">
                                <div class="mb-5 mt-2" style="text-align: center">
                                    <img _ngcontent-ng-c683320295=""
                                         class="profile-image"
                                         style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                         src="assets/imagesNew/table_error.png" />
                                </div>
                                <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                                <div class=""
                                     style="text-align: center; font-size: large; color: #1d428f">


                                    <i>No records found</i>
                                </div>
                            </div>
                        </ng-template>
                    </p-table>

                    <!-- NOTE: If internal empty message didn't render' -->
                    <!--<div id="emptymessage" class="w-12 pt-6" *ngIf="problem">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/table_error.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>No records found</i>
                        </div>
                    </div>-->
                    <!-- NOTE: If internal empty message didn't render' -->
                    <div id="emptymessage" class="w-12 pt-6" *ngIf="isProblem">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/LOCK.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>You are not authorized to view this data</i>
                        </div>
                    </div>


                </div>
                <div *ngIf="problem?.length > 0"
                     class="card-footer d-flex pt-3"
                     style="float: right !important">
                    <!--<span class="text-right"><a routerLink="/Patient/problems/list" title="View all patient problems" class="icon-link">Showmore...</a></span>-->
                    <a routerLink="/Patient/problems/list"
                       pbutton=""
                       pripple=""
                       label="View all patient problems"
                       icon="pi pi-arrow-circle-right"
                       class="p-button-text p-button-plain p-ripple p-button p-component p-0"
                       ng-reflect-label="Show more..."
                       ng-reflect-icon="pi pi-cloud-download">
                        <span class="p-button-label">Show more...</span>
                        <span class="p-button-icon p-button-icon-left pi pi-arrow-circle-right"
                              aria-hidden="true"></span>
                    </a>
                </div>
            </div>
            <!-- /.card-->
        </div>
        <!-- /.field-->

        <div class="field col-12 md:col-4">
            <div class="card widget-tasks pt-0 pr-0 pb-6 pl-0"
                 style="
          border-top-left-radius: 20px !important;
          border-top-right-radius: 20px !important;
        ">
                <div class="DashboardCard dashboardTable">
                    <div class="card-header block mb-0 px-2">
                        <h5 style="">
                            <i class="pi">
                                <img src="../../../../assets/imagesNew/d_allergeis.png"
                                     width="29"
                                     height="29"
                                     style="border: 1px solid #0d1b9c; border-radius: 1rem" />
                            </i>
                        </h5>
                        <div class="card-header-label">{{preferences?.allergies || 'Allergies'}}</div>
                    </div>

                    <p-table class="tableDashboard"
                             *ngIf="allergy"
                             [columns]="allergycols"
                             [value]="allergy"
                             selectionMode="single"
                             [resetPageOnSort]="false"
                             [lazy]="false"
                             [rows]="5"
                             [paginator]="false">
                        <ng-template *ngIf="allergy?.length > 0"
                                     pTemplate="header"
                                     let-columns>
                            <tr>
                                <th *ngFor="let col of columns"
                                    [pSortableColumn]="col.field"
                                    class="datatable-tableHeader">
                                    {{ col.header }}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body"
                                     let-rowData
                                     let-columns="columns"
                                     let-i="rowIndex">
                            <tr [pSelectableRow]="rowData" (click)="redirectUrlLinks('allergy')">
                                <td *ngFor="let col of columns" class="datatable-col">
                                    <span [innerHTML]="formatdatetime(rowData[col.field], col.header)" (mouseover)="handleMouseOver($event,'allergy','Allergen/Reaction')"></span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <div class="w-12 pt-6">
                                <div class="mb-5 mt-2" style="text-align: center">
                                    <img _ngcontent-ng-c683320295=""
                                         class="profile-image"
                                         style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                         src="assets/imagesNew/table_error.png" />
                                </div>
                                <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                                <div class=""
                                     style="text-align: center; font-size: large; color: #1d428f">
                                    <i>No records found</i>
                                </div>
                            </div>
                        </ng-template>
                    </p-table>

                    <!-- NOTE: If internal empty message didn't render' -->
                    <!--<div class="w-12 pt-6" *ngIf="allergy">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/table_error.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>No records found</i>
                        </div>
                    </div>-->
                    <!-- NOTE: If internal empty message didn't render' -->
                    <div id="emptymessage" class="w-12 pt-6" *ngIf="isAllergy">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/LOCK.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>You are not authorized to view this data</i>
                        </div>
                    </div>



                </div>
                <div *ngIf="allergy?.length > 0"
                     class="card-footer d-flex pt-3"
                     style="float: right !important">
                    <!--<span class="text-right"><a routerLink="/Patient/problems/list" title="View all patient problems" class="icon-link">Show more...</a></span>-->
                    <a routerLink="/Patient/allergy/list"
                       title="View all patient allergies"
                       pbutton=""
                       pripple=""
                       label="View all patient allergies"
                       icon="pi pi-arrow-circle-right"
                       class="p-button-text p-button-plain p-ripple p-button p-component p-0"
                       ng-reflect-label="Show more..."
                       ng-reflect-icon="pi pi-cloud-download">
                        <span class="p-button-label">Show more...</span>
                        <span class="p-button-icon p-button-icon-left pi pi-arrow-circle-right"
                              aria-hidden="true"></span>
                    </a>
                </div>
            </div>
        </div>

        <div class="field col-12 md:col-4">
            <div class="card widget-tasks pt-0 pr-0 pb-6 pl-0"
                 style="
          border-top-left-radius: 20px !important;
          border-top-right-radius: 20px !important;
        ">
                <div class="DashboardCard dashboardTable">
                    <!--<h5><i class="pi pi-bars"></i>   Medications</h5>-->
                    <div class="card-header block mb-0 px-2">
                        <h5 style="">
                            <i class="pi">
                                <img src="../../../../assets/imagesNew/d_medication.png"
                                     width="29"
                                     height="29" />
                            </i>
                        </h5>
                        <div class="card-header-label">{{preferences?.medications || 'Medication'}}</div>
                    </div>
                    <p-table class="tableDashboard"
                             *ngIf="medication"
                             [columns]="medcols"
                             [value]="medication"
                             selectionMode="single"
                             [resetPageOnSort]="false"
                             [lazy]="false"
                             [rows]="5"
                             [paginator]="false">
                        <ng-template *ngIf="medication?.length > 0"
                                     pTemplate="header"
                                     let-columns>
                            <tr>
                                <th *ngFor="let col of columns"
                                    [pSortableColumn]="col.field"
                                    class="datatable-tableHeader">
                                    {{ col.header }}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body"
                                     let-rowData
                                     let-columns="columns"
                                     let-i="rowIndex">
                            <tr [pSelectableRow]="rowData">
                                <td *ngFor="let col of columns" class="datatable-col" (click)="redirectUrlLinks('medication')">


                                    <span [innerHTML]="formatdatetime(rowData[col.field], col.header)" (mouseover)="handleMouseOver($event,'medication','Name/Dose')"></span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <div class="w-12 pt-6">
                                <div class="mb-5 mt-2" style="text-align: center">
                                    <img _ngcontent-ng-c683320295=""
                                         class="profile-image"
                                         style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                         src="assets/imagesNew/table_error.png" />
                                </div>
                                <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                                <div class=""
                                     style="text-align: center; font-size: large; color: #1d428f">
                                    <i>No records found</i>
                                </div>
                            </div>
                        </ng-template>
                    </p-table>

                    <!-- NOTE: If internal empty message didn't render' -->
                    <!--<div class="w-12 pt-6" *ngIf="medication">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/table_error.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>No records found1</i>
                        </div>
                    </div>-->

                    <div id="emptymessage" class="w-12 pt-6" *ngIf="isMedication">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/LOCK.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>You are not authorized to view this data</i>
                        </div>
                    </div>


                </div>
                <div *ngIf="medication?.length > 0"
                     class="card-footer d-flex pt-3"
                     style="float: right !important">
                    <a routerLink="/Patient/medication/list"
                       pbutton=""
                       pripple=""
                       label="View all patient medications"
                       icon="pi pi-arrow-circle-right"
                       class="p-button-text p-button-plain p-ripple p-button p-component p-0"
                       ng-reflect-label="Show more..."
                       ng-reflect-icon="pi pi-cloud-download">
                        <span class="p-button-label">Show more...</span>
                        <span class="p-button-icon p-button-icon-left pi pi-arrow-circle-right"
                              aria-hidden="true"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-4">
            <div class="card widget-tasks pt-0 pr-0 pb-6 pl-0"
                 style="
          border-top-left-radius: 20px !important;
          border-top-right-radius: 20px !important;
        ">
                <div class="DashboardCard dashboardTable">
                    <div class="card-header block mb-0 px-2">
                        <h5 style="">
                            <i class="pi">
                                <img src="../../../../assets/imagesNew/d_visits.png"
                                     width="29"
                                     height="29"
                                     style="border: 1px solid #0d1b9c; border-radius: 1rem" />
                            </i>
                        </h5>
                        <div class="card-header-label">{{preferences?.visits || 'Visits'}}</div>
                    </div>
                    <p-table class="tableDashboard"
                             *ngIf="visits"
                             [columns]="visitcols"
                             [value]="visits"
                             selectionMode="single"
                             [resetPageOnSort]="false"
                             [lazy]="false"
                             [rows]="5"
                             [paginator]="false">
                        <ng-template *ngIf="visits?.length > 0"
                                     pTemplate="header"
                                     let-columns>
                            <tr>
                                <th *ngFor="let col of columns"
                                    [pSortableColumn]="col.field"
                                    class="datatable-tableHeader">
                                    {{ col.header }}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body"
                                     let-rowData
                                     let-columns="columns"
                                     let-i="rowIndex">
                            <tr [pSelectableRow]="rowData">
                                <td *ngFor="let col of columns" class="datatable-col" (click)="redirectUrlLinks('visits')">
                                    <span [innerHTML]="formatdatetime(rowData[col.field], col.header)" (mouseover)="handleMouseOver($event,'visits','Visit Type')"></span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <div class="w-12 pt-6">
                                <div class="mb-5 mt-2" style="text-align: center">
                                    <img _ngcontent-ng-c683320295=""
                                         class="profile-image"
                                         style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                         src="assets/imagesNew/table_error.png" />
                                </div>
                                <hr style="margin-bottom: 0.3rem; margin-top: 10px" />
                                <div class=""
                                     style="text-align: center; font-size: large; color: #1d428f">
                                    <i>No records found</i>
                                </div>
                            </div>
                        </ng-template>
                    </p-table>

                    <!-- NOTE: If internal empty message didn't render' -->
                    <!--<div class="w-12 pt-6" *ngIf="visits">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/table_error.png" />
                        </div>
                        <hr style="margin-bottom: 0.3rem; margin-top: 20px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>No records found</i>
                        </div>
                    </div>-->



                    <div id="emptymessage" class="w-12 pt-6" *ngIf="isVisits">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/LOCK.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>You are not authorized to view this data</i>
                        </div>
                    </div>



                </div>

                <div *ngIf="visits?.length > 0"
                     class="card-footer d-flex pt-3"
                     style="float: right !important">
                    <a routerLink="/Patient/visits/list"
                       pbutton=""
                       pripple=""
                       label="View all patient visits"
                       icon="pi pi-arrow-circle-right"
                       class="p-button-text p-button-plain p-ripple p-button p-component p-0"
                       ng-reflect-label="Show more..."
                       ng-reflect-icon="pi pi-cloud-download">
                        <span class="p-button-label">Show more...</span>
                        <span class="p-button-icon p-button-icon-left pi pi-arrow-circle-right"
                              aria-hidden="true"></span>
                    </a>
                </div>
            </div>
        </div>

        <div class="field col-12 md:col-4">
            <div class="card widget-tasks pt-0 pr-0 pb-6 pl-0"
                 style="
          border-top-left-radius: 20px !important;
          border-top-right-radius: 20px !important;
        ">
                <div class="DashboardCard dashboardTable">
                    <!--<h5><i class="pi pi-calendar"></i>   Labs</h5>-->
                    <div class="card-header block mb-0 px-2">
                        <h5 style="">
                            <i class="pi">
                                <img src="../../../../assets/imagesNew/d_labs.png"
                                     width="26"
                                     height="26" />
                            </i>
                        </h5>
                        <div class="card-header-label">{{preferences?.labs || 'Labs'}}</div>
                    </div>

                    <p-table class="tableDashboard"
                             *ngIf="labs"
                             [columns]="labcols"
                             [value]="labs"
                             selectionMode="single"
                             [resetPageOnSort]="false"
                             [lazy]="false"
                             [rows]="5"
                             [paginator]="false">
                        <ng-template *ngIf="labs?.length > 0"
                                     pTemplate="header"
                                     let-columns>
                            <tr>
                                <th *ngFor="let col of columns"
                                    [pSortableColumn]="col.field"
                                    class="datatable-tableHeader">
                                    {{ col.header }}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body"
                                     let-rowData
                                     let-columns="columns"
                                     let-i="rowIndex">
                            <tr [pSelectableRow]="rowData">
                                <td *ngFor="let col of columns" class="datatable-col" (click)="redirectUrlLinks('labs')">
                                    <span [innerHTML]="formatdatetime(rowData[col.field], col.header)" (mouseover)="handleMouseOver($event,'labs','Test Name')"></span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <div class="w-12 pt-6">
                                <div class="mb-5 mt-2" style="text-align: center">
                                    <img _ngcontent-ng-c683320295=""
                                         class="profile-image"
                                         style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                         src="assets/imagesNew/table_error.png" />
                                </div>
                                <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                                <div class=""
                                     style="text-align: center; font-size: large; color: #1d428f">
                                    <i>No records found</i>
                                </div>
                            </div>
                        </ng-template>
                    </p-table>

                    <!-- NOTE: If internal empty message didn't render' -->
                    <!--<div class="w-12 pt-6" *ngIf="labs">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/table_error.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>No records found</i>
                        </div>
                    </div>-->


                    <div id="emptymessage" class="w-12 pt-6" *ngIf="isLabs">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/LOCK.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>You are not authorized to view this data</i>
                        </div>
                    </div>

                </div>
                <div *ngIf="labs?.length > 0"
                     class="card-footer d-flex pt-3"
                     style="float: right !important">
                    <a routerLink="/Patient/labs/list"
                       pbutton=""
                       pripple=""
                       label="View all patient labs"
                       icon="pi pi-arrow-circle-right"
                       class="p-button-text p-button-plain p-ripple p-button p-component p-0"
                       ng-reflect-label="Show more..."
                       ng-reflect-icon="pi pi-cloud-download">
                        <span class="p-button-label">Show more...</span>
                        <span class="p-button-icon p-button-icon-left pi pi-arrow-circle-right"
                              aria-hidden="true"></span>
                    </a>
                </div>
            </div>
        </div>

        <div class="field col-12 md:col-4">
            <div class="card widget-tasks pt-0 pr-0 pb-6 pl-0"
                 style="
          border-top-left-radius: 20px !important;
          border-top-right-radius: 20px !important;
        ">
                <div class="DashboardCard dashboardTable">
                    <!--<h5><i class="pi pi-id-card"></i>   Orders</h5>-->
                    <div class="card-header block mb-0 px-2">
                        <h5 style="">
                            <i class="pi">
                                <img src="../../../../assets/imagesNew/d_orders.png"
                                     width="29"
                                     height="29" />
                            </i>
                        </h5>
                        <div class="card-header-label">{{preferences?.orders || 'Orders'}}</div>
                    </div>

                    <p-table class="tableDashboard"
                             *ngIf="orders"
                             [columns]="ordercols"
                             [value]="orders"
                             selectionMode="single"
                             [resetPageOnSort]="false"
                             [lazy]="false"
                             [rows]="5"
                             [paginator]="false">
                        <ng-template *ngIf="orders?.length > 0"
                                     pTemplate="header"
                                     let-columns>
                            <tr>
                                <th *ngFor="let col of columns"
                                    [pSortableColumn]="col.field"
                                    class="datatable-tableHeader">
                                    {{ col.header }}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body"
                                     let-rowData
                                     let-columns="columns"
                                     let-i="rowIndex">
                            <tr [pSelectableRow]="rowData">
                                <td *ngFor="let col of columns" class="datatable-col" (click)="redirectUrlLinks('orders')">
                                    <span [innerHTML]="formatdatetime(rowData[col.field], col.header)" (mouseover)="handleMouseOver($event,'orders','Description')"></span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <div class="w-12 pt-6">
                                <div class="mb-5 mt-2" style="text-align: center">
                                    <img _ngcontent-ng-c683320295=""
                                         class="profile-image"
                                         style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                         src="assets/imagesNew/table_error.png" />
                                </div>
                                <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                                <div class=""
                                     style="text-align: center; font-size: large; color: #1d428f">
                                    <i>No records found</i>
                                </div>
                            </div>
                        </ng-template>
                    </p-table>

                    <!-- NOTE: If internal empty message didn't render' -->
                    <!--<div class="w-12 pt-6" *ngIf="orders">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/table_error.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>No records found</i>
                        </div>
                    </div>-->

                    <div id="emptymessage" class="w-12 pt-6" *ngIf="isOrders">
                        <div class="mb-5 mt-2" style="text-align: center">
                            <img _ngcontent-ng-c683320295=""
                                 class="profile-image"
                                 style="border-radius: 50%; width: 8rem; padding-top: 0.8rem"
                                 src="assets/imagesNew/LOCK.png" />
                        </div>
                        <hr style="margin-bottom: 0.1rem; margin-top: 10px" />
                        <div class=""
                             style="text-align: center; font-size: large; color: #1d428f">
                            <i>You are not authorized to view this data</i>
                        </div>
                    </div>

                </div>

                <div *ngIf="orders?.length > 0"
                     class="card-footer d-flex pt-3"
                     style="float: right !important">
                    <a routerLink="/Patient/orders/list"
                       pbutton=""
                       pripple=""
                       label="View all patient orders"
                       icon="pi pi-arrow-circle-right"
                       class="p-button-text p-button-plain p-ripple p-button p-component p-0"
                       ng-reflect-label="Show more..."
                       ng-reflect-icon="pi pi-cloud-download">
                        <span class="p-button-label">Show more...</span>
                        <span class="p-button-icon p-button-icon-left pi pi-arrow-circle-right"
                              aria-hidden="true"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Modal -->
<!--<div *ngIf="showModal" class="modal-overlay" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <h4>Description</h4>
        <p>{{ modalContent }}</p>
        <button (click)="closeModal()">Close</button>
    </div>
</div>-->
<!--<p-dialog [(visible)]="showDescription" [modal]="true" [style]="{ width: '45rem' }">
     Custom Header
    <ng-template pTemplate="header">
        <div style="display: flex; align-items: center; justify-content: flex-start;">
            <img [src]="iconpath" width="24" height="24" style="margin: 0; padding: 0;" />
            <span style="margin: 0; padding: 0;">&nbsp;{{ headerTitle }}</span>
        </div>
    </ng-template>

     Dialog Content
    <span>
        {{ modalContent }}
    </span>

</p-dialog>-->
<!--<p-dialog [(visible)]="showDescription"
          [modal]="false"
          [style]="{ width: '45rem' }"
          [positionStyle]="{ left: dialogLeft + 'px', top: dialogTop + 'px', position: 'fixed' }"
          [baseZIndex]="10000"
          [dismissableMask]="true">

    <ng-template pTemplate="header">
        <div style="display: flex; align-items: center; justify-content: flex-start;">
            <img [src]="iconpath" width="24" height="24" style="margin: 0; padding: 0;" />
            <span style="margin: 0; padding: 0;">&nbsp;{{ headerTitle }}</span>
        </div>
    </ng-template>


    <span>
        {{ modalContent }}
    </span>
</p-dialog>-->


<p-dialog [(visible)]="showDescription"
          [modal]="false"
          [dismissableMask]="true"
          [baseZIndex]="10000"
          [style]="{
   width: '100%',
    maxWidth: '45rem',
    left: dialogLeft + 'px',
    top: dialogTop + 'px',
    position: 'fixed',
           maxHeight: '90vh',
    overflow: 'auto'
  }">
    <ng-template pTemplate="header">
        <div style="display: flex; align-items: center; justify-content: flex-start;">
            <img [src]="iconpath" width="24" height="24" style="margin: 0; padding: 0;" />
            <span style="margin: 0; padding: 0;">&nbsp;{{ headerTitle }}</span>
        </div>
    </ng-template>


    <span>
        {{ modalContent }}
    </span>
</p-dialog>
